import { Button, Dialog, Text } from '@noorden-insurtech/alba-design-system';
import { AlertCircle, FileText } from 'lucide-react';

interface DownloadPdfDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  isError?: boolean;
  title?: string;
  message?: string;
  /** Substitui o texto genérico de falha (ex.: documento ainda indisponível). */
  errorMessage?: string;
}

export function DownloadPdfDialog({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
  isError = false,
  title = 'Baixar PDF',
  message = 'O PDF será baixado para o seu dispositivo.',
  errorMessage = 'Não foi possível baixar o PDF. Tente novamente mais tarde.',
}: DownloadPdfDialogProps) {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content className='w-[480px] max-w-[480px] rounded-[24px] p-6 shadow-xl'>
          <div className='flex flex-col items-start gap-8'>
            <Dialog.Header className='w-full p-0'>
              <Dialog.Title className='w-full'>
                <div className='flex w-full items-center justify-between gap-3'>
                  <div className='flex items-center gap-2'>
                    <FileText className='h-6 w-6 text-alba-black-500' />
                    <Text className='text-lg font-bold text-alba-black-500'>
                      {title}
                    </Text>
                  </div>
                  <Dialog.CloseButton onClick={onClose} />
                </div>
              </Dialog.Title>
            </Dialog.Header>

            <Dialog.Body className='w-full px-6 py-0'>
              {isError ? (
                <div className='flex items-start gap-3 rounded-xl border border-red-200 bg-red-50 px-4 py-3'>
                  <AlertCircle className='mt-0.5 h-5 w-5 shrink-0 text-red-500' />
                  <Text className='text-sm text-red-700'>{errorMessage}</Text>
                </div>
              ) : (
                <div className='flex flex-col items-start gap-2'>
                  <Text className='text-sm text-alba-gray-600'>{message}</Text>
                  <Text className='text-sm text-alba-gray-600'>
                    Deseja continuar?
                  </Text>
                </div>
              )}
            </Dialog.Body>

            <Dialog.Footer className='w-full p-0 px-6'>
              <div className='flex w-full items-center justify-end gap-6'>
                <Dialog.CloseTrigger asChild>
                  <Button variant='ghost' size='md'>
                    Cancelar
                  </Button>
                </Dialog.CloseTrigger>
                <Button
                  variant='primary'
                  size='md'
                  loading={isLoading}
                  disabled={isLoading}
                  onClick={onConfirm}
                >
                  {isError ? 'Tentar novamente' : 'Baixar'}
                </Button>
              </div>
            </Dialog.Footer>
          </div>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
}
